import { Schema } from "effect";
const CursorSchema = Schema.Struct({
    id: Schema.Number
});
const CursorUrlParams = Schema.compose(Schema.StringFromBase64Url, Schema.parseJson(CursorSchema));
export const UrlParams = Schema.Struct({
    limit: Schema.NumberFromString.pipe(Schema.optionalWith({
        default: ()=>100
    })),
    cursor: CursorUrlParams.pipe(Schema.optional)
});
export const Pagination = Schema.Union(Schema.Struct({
    hasMore: Schema.Literal(true),
    cursor: CursorUrlParams
}), Schema.Struct({
    hasMore: Schema.Literal(false),
    cursor: Schema.Null
}));
export class Model extends Schema.Class("superwall-api-WebPaywallDomain-Model")({
    object: Schema.Literal("web_paywall_domain"),
    createdAt: Schema.DateFromString,
    deletedAt: Schema.DateFromString.pipe(Schema.NullOr),
    domain: Schema.String.pipe(Schema.NullOr),
    baseDomain: Schema.String
}) {
}
export class Create extends Schema.Class("superwall-api-WebPaywallDomain-Create")({
    domain: Schema.String
}) {
}
export class List extends Schema.Class("superwall-api-WebPaywallDomain-List")({
    object: Schema.Literal("list"),
    data: Schema.Array(Model),
    pagination: Pagination
}) {
}
export class Availability extends Schema.Class("superwall-api-WebPaywallDomain-Availability")({
    available: Schema.Boolean
}) {
}
